import {Route} from '@angular/router';

export const mainRoutes: Route[] = [
  {
    path: 'dashboard',
    loadChildren: './dashboard/dashboard.module#DashboardModule',
    data: {
      icon: 'ic_menu_dashboard',
      label: 'Dashboard'
    }
  },
  {
    path: 'user',
    loadChildren: './user/user.module#UserModule',
    data: {
      icon: 'ic_menu_users',
      label: 'Users'
    }
  },
  {
    path: 'project',
    loadChildren: './project/project.module#ProjectModule',
    data: {
      icon: 'ic_menu_projects',
      label: 'Projects'
    }
  },
  {
    path: 'hardware',
    loadChildren: './hardware/hardware.module#HardwareModule',
    data: {
      icon: 'ic_menu_hw_models',
      label: 'Hardware'
    }
  },
  {
    path: 'unit-type',
    loadChildren: './unit-type/unit-type.module#UnitTypeModule',
    data: {
      icon: 'ic_menu_hw_models',
      label: 'Unit types'
    }
  },
  {
    path: 'unit-model',
    loadChildren: './unit-model/unit-model.module#UnitModelModule',
    data: {
      icon: 'ic_menu_models',
      label: 'Models'
    }
  },
  {
    path: 'unit',
    loadChildren: './unit/unit.module#UnitModule',
    data: {
      icon: 'ic_menu_units',
      label: 'Units'
    }
  },
  {
    path: 'battery',
    loadChildren: './battery/battery.module#BatteryModule',
    data: {
      icon: 'ic_menu_batteries',
      label: 'Batteries'
    }
  },
  {
    path: 'geo-objects',
    loadChildren: './geo-objects/geo-objects.module#GeoObjectsModule',
  },
  {
    path: 'end-user-price-plan',
    loadChildren: './end-user-price-plan/end-user-price-plan.module#EndUserPricePlanModule',
    data: {
      icon: 'ic_menu_price_plans',
      label: 'Price plans'
    }
  },
  {
    path: 'executor-price-plan',
    loadChildren: './executor-price-plan/executor-price-plan.module#ExecutorPricePlanModule',
    data: {
      icon: 'ic_menu_price_plans',
      label: 'Courier price plans'
    }
  },
  {
    path: 'prepaid-sharing-price-plan',
    loadChildren: './prepaid-sharing-price-plan/prepaid-sharing-price-plan.module#PrepaidSharingPricePlanModule',
    data: {
      icon: 'ic_menu_price_plans',
      label: 'For QR sharing'
    }
  },
  {
    path: 'services',
    loadChildren: './services/services.module#ServicesModule',
    data: {
      icon: 'ic_menu_services',
      label: 'Services'
    }
  },
  {
    path: 'notification',
    loadChildren: './notification/notification.module#NotificationModule',
    data: {
      icon: 'ic_menu_notifications',
      label: 'Notifications'
    }
  },
  {
    path: 'promotions-and-news',
    loadChildren: './promotions-and-news/promotions-and-news.module#PromotionsAndNewsModule',
    data: {
      label: 'News',
    }
  },
  {
    path: 'service-request',
    loadChildren: './service-request/service-request.module#ServiceRequestModule',
    data: {
      icon: 'ic_menu_service_requests',
      label: 'Service requests'
    }
  },
  {
    path: 'end-user',
    loadChildren: './end-user/end-user.module#EndUserModule',
    data: {
      icon: 'ic_menu_clients',
      label: 'Clients'
    }
  },
  {
    path: 'end-user-anonymous',
    loadChildren: './end-user-anonymous/end-user-anonymous.module#EndUserAnonymousModule',
    data: {
      icon: 'ic_menu_clients',
      label: 'Anonymous clients'
    }
  },
  {
    path: 'end-user-suspicious',
    loadChildren: './end-user/suspicious-client/suspicious-client.module#SuspiciousClientModule',
    data: {
      icon: 'ic_menu_clients',
      label: 'Suspicious clients'
    }
  },
  {
    path: 'executor-courier',
    loadChildren: './courier/courier.module#CourierModule',
    data: {
      icon: 'ic_menu_employee',
      label: 'Couriers',
    }
  },
  {
    path: 'employee',
    loadChildren: './base-employee/redirect/base-employee.module#BaseEmployeeModule',
    data: {
      icon: 'ic_menu_employee',
      label: 'My couriers',
    }
  },
  {
    path: 'bag',
    loadChildren: './bag/bag.module#BagModule',
    data: {
      icon: 'ic_menu_bag',
      label: 'Bags',
    }
  },
  {
    path: 'work-shift',
    loadChildren: './work-shift/work-shift.module#WorkShiftModule',
    data: {
      icon: 'ic_menu_work-shift',
      label: 'Work shifts',
    }
  },
  {
    path: 'end-user-order',
    loadChildren: './end-user-order/end-user-order.module#EndUserOrderModule',
    data: {
      icon: 'ic_menu_orders',
      label: 'Orders'
    }
  },
  {
    path: 'prepaid-sharing-order',
    loadChildren: './prepaid-sharing-order/prepaid-sharing-order.module#PrepaidSharingOrderModule',
    data: {
      icon: 'ic_menu_orders',
      label: 'QR sharing'
    }
  },
  {
    path: 'purchases',
    loadChildren: './purchase/purchases.module#PurchasesModule',
    data: {
      icon: 'ic_menu_purchases',
      label: 'Purchases'
    }
  },
  {
    path: 'promo-code',
    loadChildren: './promo-code/promo-code.module#PromoCodeModule',
    data: {
      icon: 'ic_menu_promo_codes',
      label: 'Promo Codes'
    }
  },
  {
    path: 'statistic',
    loadChildren: './statistic/statistic.module#StatisticModule',
    data: {
      icon: 'ic_menu_analytics',
      label: 'Analytics',
    }
  },
  {
    path: 'order-search',
    loadChildren: './dashboard/find-orders/find-orders.module#FindOrdersModule',
    data: {
      icon: 'ic_menu_analytics',
      label: 'Find orders',
    }
  },
  {
    path: 'business-logic',
    loadChildren: './business-logic/business-logic.module#BusinessLogicModule',
    data: {
      icon: 'ic_menu_analytics',
      label: 'Business model',
    }
  },
  {
    path: 'order-statistic',
    loadChildren: './dashboard/end-user-statistics/end-user-statistics.module#EndUserStatisticsModule',
    data: {
      icon: 'ic_menu_analytics',
      label: 'Ordering statistics',
    }
  },
  {
    path: 'component-type',
    loadChildren: './component-type/component-type-list/component-type-list.module#ComponentTypeListModule',
    data: {
      icon: 'ic_menu_units',
      label: 'Component types',
    }
  },
  {
    path: 'component-model',
    loadChildren: './component-model/component-model-list/component-model-list.module#ComponentModelListModule',
    data: {
      icon: 'ic_menu_units',
      label: 'Component models',
    }
  },
  {
    path: 'component',
    loadChildren: './component/component-list/component-list.module#ComponentListModule',
    data: {
      icon: 'ic_menu_units',
      label: 'Components',
    }
  },
  {
    path: 'component-without-sn',
    loadChildren: './component/component-without-sn-list/component-without-sn-list.module#ComponentWithoutSnListModule',
    data: {
      label: 'Components without s/n',
    }
  },
  {
    path: 'warehouse',
    loadChildren: './warehouse/warehouse-list/warehouse-list.module#WarehouseListModule',
    data: {
      label: 'Warehouse',
    }
  },
  {
    path: 'legal-entity',
    loadChildren: './legal-entity/legal-entity-list/legal-entity-list.module#LegalEntityListModule',
    data: {
      icon: 'ic_menu_units',
      label: 'Legal entities',
    }
  },
  {
    path: 'branch-office',
    loadChildren: './branch-office/branch-office-list/branch-office-list.module#BranchOfficeListModule',
    data: {
      icon: 'ic_menu_units',
      label: 'Branch offices',
    }
  },
  {
    path: 'diagnostics',
    loadChildren: './diagnostics/diagnostics.module#DiagnosticsModule',
    data: {
      icon: 'ic_menu_diagnostics',
      label: 'Diagnostics'
    }
  },
];
